import { Navigate, Route, Routes } from "react-router-dom"
import SearchParams from "simplydo/core/searchParams"
import styled from "styled-components"

import { StyledDashboard } from "components/AppOnboarding"
import DownloadAppBanner from "components/home/DownloadAppBanner"
import { useAppSelector } from "store"

import Enrol from "./Enrol"
import ForgottenPassword from "./ForgottenPassword"
import Login from "./Login"
import RegisterFlow from "./RegisterFlow"
import ResetPassword from "./ResetPassword"

const StyledEntry = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
`

const Entry = () => {
  const user = useAppSelector((state) => state.user)

  if (user) {
    const params = new SearchParams(window.location.search)
    const then = params.get("then") ?? "/"
    const code = params.get("code")
    if (then && (!code || (code && user?.ownerOrganisation?.code === code))) {
      return <Navigate to={then} replace />
    }
  }

  return (
    <StyledEntry>
      <DownloadAppBanner />
      <Routes>
        <Route
          path="password/forgotten"
          element={<StyledDashboard excludeWelcomeText padded="very" content={<ForgottenPassword />} />}
        />
        <Route
          path="password/reset"
          element={<StyledDashboard excludeWelcomeText padded="very" content={<ResetPassword />} />}
        />
        <Route
          path="enrol"
          element={<StyledDashboard excludeWelcomeText padded="very" scrolling={false} content={<Enrol />} />}
        />
        <Route
          path="register"
          element={<StyledDashboard excludeWelcomeText scrolling={false} padded="very" content={<RegisterFlow />} />}
        />
        <Route
          path="*"
          element={
            <StyledDashboard
              backgroundColor="#14435B"
              excludeWelcomeText
              scrolling={false}
              padded="very"
              content={<Login />}
            />
          }
        />
      </Routes>
    </StyledEntry>
  )
}

export default Entry
